import { RECEIPT_NAME_NONE_MEMBER, RECEIPT_TYPES } from '@autopass-web/domain';

import type { ValueOf } from '@autopass-web/types';

// carrier_citizen_digital are not in used
export type ReceiptsTypeValue = ValueOf<typeof RECEIPT_TYPES>;

type Info = {
  [T in ReceiptsTypeValue]: {
    key: string;
    name: string;
    value: T;
    order: number;
  };
};

export const RECEIPTS_INFO = {
  // 手機條碼載具
  carrier_mobile_barcode: {
    key: 'CARRIER_MOBILE_BARCODE',
    name: RECEIPT_NAME_NONE_MEMBER[RECEIPT_TYPES['CARRIER_MOBILE_BARCODE']],
    value: 'carrier_mobile_barcode',
    order: 1,
  },
  // 統編發票
  b2b: {
    key: 'B2B',
    name: RECEIPT_NAME_NONE_MEMBER[RECEIPT_TYPES['B2B']],
    value: 'b2b',
    order: 2,
  },
  // 捐贈發票
  donate: {
    key: 'DONATE',
    name: RECEIPT_NAME_NONE_MEMBER[RECEIPT_TYPES['DONATE']],
    value: 'donate',
    order: 3,
  },
  // 名字很怪，但這是信箱載具
  carrier_member: {
    key: 'CARRIER_MEMBER',
    name: RECEIPT_NAME_NONE_MEMBER[RECEIPT_TYPES['CARRIER_MEMBER']],
    value: 'carrier_member',
    order: 4,
  },
  // 自然人憑證載具
  carrier_citizen_digital: {
    key: 'CARRIER_CITIZEN_DIGITAL',
    name: RECEIPT_NAME_NONE_MEMBER[RECEIPT_TYPES['CARRIER_CITIZEN_DIGITAL']],
    value: 'carrier_citizen_digital',
    order: 5,
  },
  // 平台載具
  payment_carrier: {
    key: 'PAYMENT_CARRIER',
    name: RECEIPT_NAME_NONE_MEMBER[RECEIPT_TYPES['PAYMENT_CARRIER']],
    value: 'payment_carrier',
    order: 6,
  },
} as const satisfies Info;

export const receiptTypes = Object.keys(RECEIPTS_INFO) as ReceiptsTypeValue[];

export interface ReceiptInfoBase {
  type: ReceiptsTypeValue;
}
